module.exports = [
	{
		"count": 2,
		"units_per_day": 1.6,
		"usage_time_per_day": 4,
		"total_kw": 0.4,
		"kw": 0.2,
		"name": "TV",
		"time_of_day_usage": 18,
		"cost_per_day": 0.416,
		"id": "tv",
		"room": "livingroom"
	},
	{
		"count": 1,
		"units_per_day": 1.8,
		"usage_time_per_day": 2,
		"total_kw": 0.9,
		"kw": 0.9,
		"name": "Washing machine",
		"time_of_day_usage": 14,
		"cost_per_day": 0.468,
		"id": "washing_machine",
		"room": "bathroom"
	},
	{
		"count": 15,
		"units_per_day": 0.9,
		"usage_time_per_day": 1,
		"total_kw": 0.9,
		"kw": 0.06,
		"name": "60W Lights",
		"time_of_day_usage": 18,
		"cost_per_day": 0.234,
		"id": "lights",
		"room": "livingroom"
	},
	{
		"count": 3,
		"units_per_day": 0.09,
		"usage_time_per_day": 2,
		"total_kw": 0.045,
		"kw": 0.015,
		"name": "LED Desk light",
		"time_of_day_usage": 20,
		"cost_per_day": 0.0234,
		"id": "desk_light",
		"room": "study"
	},
	{
		"count": 1,
		"units_per_day": 5.04,
		"usage_time_per_day": 24,
		"total_kw": 0.21,
		"kw": 0.21,
		"name": "Fridge",
		"time_of_day_usage": 0,
		"cost_per_day": 1.3104,
		"id": "fridge",
		"room": "kitchen"
	},
	{
		"count": 1,
		"units_per_day": 1.8,
		"usage_time_per_day": 4,
		"total_kw": 0.45,
		"kw": 0.45,
		"name": "PC",
		"time_of_day_usage": 16,
		"cost_per_day": 0.468,
		"id": "pc",
		"room": "study"
	},
	{
		"count": 1,
		"units_per_day": 0.15,
		"usage_time_per_day": 3,
		"total_kw": 0.05,
		"kw": 0.05,
		"name": "Laptop",
		"time_of_day_usage": 17,
		"cost_per_day": 0.039,
		"id": "laptop",
		"room": "bedroom"
	},
	{
		"count": 1,
		"units_per_day": 1.3,
		"usage_time_per_day": 1,
		"total_kw": 1.3,
		"kw": 1.3,
		"name": "Microwave",
		"time_of_day_usage": 19,
		"cost_per_day": 0.338,
		"id": "microwave",
		"room": "kitchen"
	},
	{
		"count": 1,
		"units_per_day": 3.2,
		"usage_time_per_day": 2,
		"total_kw": 1.6,
		"kw": 1.6,
		"name": "Oven",
		"time_of_day_usage": 10,
		"cost_per_day": 0.832,
		"id": "oven",
		"room": "kitchen"
	},
	{
		"count": 1,
		"units_per_day": 0.9,
		"usage_time_per_day": 0.5,
		"total_kw": 1.8,
		"kw": 1.8,
		"name": "Kettle",
		"time_of_day_usage": 7,
		"cost_per_day": 0.234,
		"id": "kettle",
		"room": "kitchen"
	},
	{
		"count": 1,
		"units_per_day": 2.2,
		"usage_time_per_day": 2,
		"total_kw": 1.1,
		"kw": 1.1,
		"name": "Vacuum",
		"time_of_day_usage": 10,
		"cost_per_day": 0.572,
		"id": "vacuum",
		"room": "livingroom"
	},
	{
		"count": 1,
		"units_per_day": 0.3,
		"usage_time_per_day": 3,
		"total_kw": 0.1,
		"kw": 0.1,
		"name": "Hi-Fi",
		"time_of_day_usage": 15,
		"cost_per_day": 0.078,
		"id": "hifi",
		"room": "livingroom"
	},
	{
		"count": 1,
		"units_per_day": 0.3,
		"usage_time_per_day": 0.5,
		"total_kw": 0.6,
		"kw": 0.6,
		"name": "Toaster",
		"time_of_day_usage": 7,
		"cost_per_day": 0.078,
		"id": "toaster",
		"room": "kitchen"
	},
	{
		"count": 1,
		"units_per_day": 0.225,
		"usage_time_per_day": 0.5,
		"total_kw": 0.45,
		"kw": 0.45,
		"name": "Blender",
		"time_of_day_usage": 7,
		"cost_per_day": 0.0585,
		"id": "blender",
		"room": "kitchen"
	},
	{
		"count": 1,
		"units_per_day": 11.5,
		"usage_time_per_day": 5,
		"total_kw": 2.3,
		"kw": 2.3,
		"name": "Air conditioner",
		"time_of_day_usage": 13,
		"cost_per_day": 2.99,
		"id": "aircon",
		"room": "study"
	},
	{
		"count": 1,
		"units_per_day": 4.8,
		"usage_time_per_day": 2,
		"total_kw": 2.4,
		"kw": 2.4,
		"name": "Dishwasher",
		"time_of_day_usage": 14,
		"cost_per_day": 1.248,
		"id": "dishwasher",
		"room": "kitchen"
	},
	{
		"count": 1,
		"units_per_day": 0.5,
		"usage_time_per_day": 0.5,
		"total_kw": 1,
		"kw": 1,
		"name": "Hair dryer",
		"time_of_day_usage": 15,
		"cost_per_day": 0.13,
		"id": "hairdryer",
		"room": "bathroom"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/appliances.json
// module id = 104
// module chunks = 0